import { styled } from '@mui/material/styles';
import { Chip } from 'shared/mui/Chips';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';
import { getColumnStyle } from 'utils';

const StickyDatagridConfigurableWithStickyActions = withDatagridStickyStyles(
  DatagridConfigurableWithStickyActions,
);

export const DatagridStyled = styled(StickyDatagridConfigurableWithStickyActions)({
  '& .column-managerVerified': {
    textAlign: 'center',
  },
  '& .column-pcidss': {
    textAlign: 'center',
  },
  '& .column-pushApi': {
    textAlign: 'center',
  },
  '& .column-defaultCurrency': {
    minWidth: '105px',
  },
  '& .column-status': {
    ...getColumnStyle(78),
    '& .MuiTypography-root': {
      minWidth: 0,
      width: 'fit-content',
      marginRight: 'auto',
      marginLeft: 'auto',
    },
  },
});

export const ChipStyled = styled(Chip)({
  '&:not(:first-child)': {
    marginTop: '12px',
  },
});
